import changeSteps from '../../../../templates/joinWithCards/tour1/modules/changeSteps';
import specialOptions from '../../../../templates/joinWithCards/tour1/modules/specialOptions';
import ogoShift from '../../../../templates/joinWithCards/tour1/modules/ogoShift';

changeSteps();
specialOptions();
ogoShift();